import {
    GET_ALL_PAYMENT_TYPES,
} from '../actions/PaymentTypeActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';
import { GET_ALL_SETTINGS } from '../actions/SettingActions';

const persistConfig = {
    key: 'setting',
    storage,
};


const initialState = {
    data: [],
    latestUpdate: '',
    loading: false,
    error: '',
}

const SettingReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_ALL_SETTINGS: {
            return {
                ...state,
                data: action.payload.data,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, SettingReducer);
